import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHandshake, 
  faCheckCircle, 
  faLightbulb, 
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/AboutPage.css';
import gerhardNeubauerImage from '../../assets/images/team/gerhard-neubaur.jpg';
import teamWork1 from '../../assets/images/team/team-work-1.jpg';
import teamWork2 from '../../assets/images/team/team-work-2.jpg';
import teamWork3 from '../../assets/images/team/team-work-3.jpg';

// Team-Bilder aus den Projektordnern
const UeberUnsPage: React.FC = () => {
  return (
    <div className="about-page">
      {/* Header Section */}
      <header 
        className="about-header"
        style={{ backgroundColor: 'var(--secondary-color)' }}
      >
        <div className="container">
          <div className="about-header-content">
            <h1>Über uns</h1>
            <p>
              Lernen Sie das Ingenieurbüro Neubaur kennen - Ihr kompetenter Partner für Elektroplanung seit vielen Jahren
            </p>
          </div>
        </div>
      </header>
      
      <div className="about-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="about-section">
            <h2 className="about-section-title">Das Ingenieurbüro Neubaur</h2>
            
            <div className="about-intro">
              <div className="about-intro-text">
                <p>
                  Das Ingenieurbüro Neubaur ist Ihr zuverlässiger Partner für Fachplanung im Bereich Elektrotechnik. 
                  Mit jahrelanger Erfahrung und einem Team aus hochqualifizierten Ingenieuren, Technikern und Zeichnern 
                  setzen wir Ihre Projekte kompetent und termingerecht um.
                </p>
                <p>
                  Unser Aufgabe heißt Fachplanung für Elektrotechnik und bedeutet: Wir planen Sicherheit, Komfort und 
                  Energieeffizienz mit System. Das Ingenieurbüro Neubaur verlässt sich im Umgang mit seinen Kunden auf 
                  Werte, die funktionieren: Zuverlässig und zielorientiert liefern wir ehrliche Arbeit mit hoher Qualität 
                  zum vereinbarten Zeitpunkt.
                </p>
                <p>
                  Dabei betreut Sie bei allen Belangen Gerhard Neubaur, der Chef und kompetente Ansprechpartner. 
                  IB Neubaur schafft wirtschaftlich sinnvolle Lösungen. Wir setzen Ihre Wünsche mit schlüssigem 
                  Denken und jahrelanger Erfahrung um.
                </p>
              </div>
              <div className="about-intro-image">
                <img 
                  src={gerhardNeubauerImage} 
                  alt="Gerhard Neubaur, Geschäftsführer des Ingenieurbüros Neubaur" 
                  className="about-intro-photo"
                />
              </div>
            </div>
            
            {/* Values Section */}
            <div className="about-values">
              <h3 className="values-title">Unsere Werte</h3>
              <div className="values-grid">
                <div className="value-item">
                  <div className="value-icon">
                    <FontAwesomeIcon icon={faHandshake} />
                  </div>
                  <h4 className="value-title">Zuverlässigkeit</h4>
                  <p className="value-text">
                    Wir stehen zu unseren Zusagen und liefern termingerecht qualitativ hochwertige Arbeit.
                  </p>
                </div>
                
                <div className="value-item">
                  <div className="value-icon">
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </div>
                  <h4 className="value-title">Qualität</h4>
                  <p className="value-text">
                    Höchste Qualitätsstandards und Präzision in allen Planungsleistungen sind für uns selbstverständlich.
                  </p>
                </div>
                
                <div className="value-item">
                  <div className="value-icon">
                    <FontAwesomeIcon icon={faLightbulb} />
                  </div>
                  <h4 className="value-title">Innovation</h4>
                  <p className="value-text">
                    Wir setzen auf moderne Technologien und innovative Lösungen für zukunftssichere Gebäudetechnik.
                  </p>
                </div>
                
                <div className="value-item">
                  <div className="value-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <h4 className="value-title">Kundenorientierung</h4>
                  <p className="value-text">
                    Ihre Wünsche und Anforderungen stehen im Mittelpunkt unserer Arbeit - wir finden die optimale Lösung für Sie.
                  </p>
                </div>
              </div>
            </div>
          </section>
          
          {/* Team Section */}
          <section className="about-section team-section">
            <h2 className="about-section-title">Unser Team</h2>
            
            {/* Geschäftsführer - Prominente Darstellung */}
            <div className="team-leader">
              <div className="leader-card">
                <div className="leader-image">
                  <img 
                    src={gerhardNeubauerImage} 
                    alt="Gerhard Neubaur, Geschäftsführer" 
                    className="leader-photo"
                  />
                </div>
                <div className="leader-details">
                  <h3 className="leader-name">Gerhard Neubaur</h3>
                  <p className="leader-position">Geschäftsführer</p>
                  <p className="leader-bio">
                    Mit langjähriger Erfahrung in der Elektroplanung leitet Herr Neubaur das Ingenieurbüro 
                    und ist Ihr kompetenter Ansprechpartner für alle Projekte. Er steht Ihnen mit 
                    gesamtheitlichem Blick und umfassenden Kenntnissen auch in Detailfragen zur Verfügung.
                  </p>
                </div>
              </div>
            </div>

            {/* Rest des Teams */}
            <div className="team-grid">
              <div className="team-member">
                <div className="team-image">
                  <img 
                    src={teamWork1} 
                    alt="Erfahrene Ingenieure bei der Planung" 
                    className="team-photo"
                    style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }}
                  />
                </div>
                <div className="team-details">
                  <h3 className="team-name">Erfahrene Ingenieure</h3>
                  <p className="team-position">Elektrotechnik</p>
                  <p className="team-bio">
                    Unser Team aus hochqualifizierten Ingenieuren sorgt für die professionelle Planung 
                    und Umsetzung Ihrer Projekte.
                  </p>
                </div>
              </div>
              
              <div className="team-member">
                <div className="team-image">
                  <img 
                    src={teamWork2} 
                    alt="Qualifizierte Techniker im Einsatz" 
                    className="team-photo"
                    style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }}
                  />
                </div>
                <div className="team-details">
                  <h3 className="team-name">Qualifizierte Techniker</h3>
                  <p className="team-position">Technische Planung</p>
                  <p className="team-bio">
                    Unsere Techniker unterstützen mit ihrem Fachwissen die technische Umsetzung 
                    und sorgen für reibungslose Abläufe.
                  </p>
                </div>
              </div>
              
              <div className="team-member">
                <div className="team-image">
                  <img 
                    src={teamWork3} 
                    alt="Präzise Zeichner bei der CAD-Arbeit" 
                    className="team-photo"
                    style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }}
                  />
                </div>
                <div className="team-details">
                  <h3 className="team-name">Präzise Zeichner</h3>
                  <p className="team-position">CAD & BIM</p>
                  <p className="team-bio">
                    Mit modernster Software erstellen unsere Zeichner präzise Pläne und 
                    3D-Modelle für Ihre Projekte.
                  </p>
                </div>
              </div>
            </div>
          </section>
          
          {/* History Section */}
          <section className="about-section history-section">
            <h2 className="about-section-title">Unsere Geschichte</h2>
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">1998</div>
                  <h3 className="timeline-title">Gründung der Gerhard Neubaur Elektroanlagen GmbH</h3>
                  <p className="timeline-text">
                    Gerhard Neubaur gründet die Gerhard Neubaur Elektroanlagen GmbH in Rain am Lech.
                  </p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">2010</div>
                  <h3 className="timeline-title">Erweiterung des Leistungsspektrums</h3>
                  <p className="timeline-text">
                    Erweiterung um die Bereiche Energietechnik und Sicherheitstechnik.
                  </p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">2012</div>
                  <h3 className="timeline-title">Umfirmierung zur IB Neubaur GmbH</h3>
                  <p className="timeline-text">
                    Das Ingenieurbüro wird zur IB Neubaur GmbH umfirmiert und erweitert seine Kapazitäten.
                  </p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">2018</div>
                  <h3 className="timeline-title">Erweiterung durch 3D-Planung</h3>
                  <p className="timeline-text">
                    Erweiterung des Leistungsspektrums um 3D-Planung und BIM-Services.
                  </p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">2024</div>
                  <h3 className="timeline-title">OpenSpace Erweiterung</h3>
                  <p className="timeline-text">
                    Integration modernster 3D-Aufnahmetechnologie für präzise Bestandserfassung und virtuelle Begehungen.
                  </p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <div className="timeline-year">Heute</div>
                  <h3 className="timeline-title">Kontinuierliches Wachstum</h3>
                  <p className="timeline-text">
                    Heute ist das IB Neubaur ein etablierter Partner für Elektroplanung in der Region mit einem breiten Leistungsspektrum.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default UeberUnsPage;